module.exports = __webpack_public_path__ + "static/media/louise-2.f7fe55d9.jpg";